/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md.
 */
/**
 * Returns heading options as defined in `config.heading.options` but processed to consider
 * editor localization, i.e. to display {@link module:heading/heading~HeadingOption}
 * in the correct language.
 *
 * Note: The reason behind this method is that there's no way to use {@link module:utils/locale~Locale#t}
 * when the user config is defined because the editor does not exist yet.
 *
 * @param {module:core/editor/editor~Editor} editor
 * @returns {Array.<module:heading/heading~HeadingOption>}.
 */
export function getLocalizedOptions(editor) {
    const t = editor.t;
    const localizedTitles = {
        Paragraph: t('bi'),
        'Heading 1': t('bj'),
        'Heading 2': t('bk'),
        'Heading 3': t('bl'),
        'Heading 4': t('bm'),
        'Heading 5': t('bn'),
        'Heading 6': t('bo')
    };
    return editor.config.get('heading.options').map(option => {
        const title = localizedTitles[option.title];
        if (title && title != option.title) {
            option.title = title;
        }
        return option;
    });
}